import React, { useEffect, useState } from "react";
import { Fab, Modal, Paper, useTheme } from "@mui/material";
import { Box } from "@mui/system";

import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { subscribeToRelay } from "./relay";
import { selectMissionSelect } from "../mission/missionSlice";
import LayersIcon from "@mui/icons-material/Layers";
import {
  getGeofenceListThunk,
  getLandingZoneListThunk,
  listLandingPadsThunk,
} from "../airspace/airspaceSlice";
import { FloatingAircraft } from "./FloatingAircraft";
import { Menu } from "../../components/Menu";
import { AircraftMenu } from "../../components/selectAircraft/AircraftMenu";
import { CommandTrayAll } from "../../components/CommandTrayAll";
import { useInterval } from "../../useInterval";
import { MapboxMap } from "../../components/mapbox/MapboxMap";

const Overview = () => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const missionSelect = useAppSelector(selectMissionSelect);
  const [showTiles, setShowTiles] = useState(false);
  const fabRef = React.useRef<HTMLButtonElement | null>(null);

  const toggleTiles = () => {
    setShowTiles(!showTiles);
  };

  useInterval(() => {
    dispatch(listLandingPadsThunk({}));
  }, 30000);

  useEffect(() => {
    dispatch(subscribeToRelay());
    dispatch(listLandingPadsThunk({}));
    dispatch(getGeofenceListThunk({}));
    dispatch(getLandingZoneListThunk({}));
    return () => {};
  }, []);

  const onClickFab = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    toggleTiles();
  };

  useEffect(() => {
    const handleTouch = (e: TouchEvent) => {
      e.preventDefault();
      toggleTiles();
    };

    const element = fabRef.current;
    element?.addEventListener("touchstart", handleTouch, { passive: false });

    return () => {
      element?.removeEventListener("touchstart", handleTouch);
    };
  }, [showTiles]);

  return (
    <>
      <Paper style={{ height: "100%", width: "100%" }}>
        <Box sx={{ height: "100vh" }} display={"flex"} flexDirection="row">
          <MapboxMap showTiles={showTiles} />
        </Box>
        <Box
          sx={{
            height: "100vh",
            width: "100vw",
            position: "absolute",
            left: 0,
            right: 0,
            top: 0,
            borderRadius: 0,
            backgroundColor: "transparent",
            pointerEvents: "none",
            zIndex: 500,
          }}
        >
          <FloatingAircraft />
        </Box>
        <Box
          sx={{
            position: "absolute",
            pointerEvents: "none",

            left: 0,
            bottom: 0,
            borderRadius: 0,
            bgcolor: "transparent",
            zIndex: 500,
          }}
        >
          <Menu />
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            bottom: 0,
            borderRadius: 0,
            bgcolor: "transparent",
            zIndex: 500,
            pointerEvents: "none",
          }}
        >
          <AircraftMenu />
        </Box>
        <Box
          sx={{
            position: "absolute",
            right: 0,
            top: 0,
            borderRadius: 0,
            bgcolor: "transparent",
            zIndex: 500,
            pointerEvents: "none",
          }}
        >
          <Fab
            ref={fabRef}
            sx={{
              position: "absolute",
              top: 16,
              right: 16,
              pointerEvents: "all",
              backgroundColor: theme.palette.background.paper,
            }}
            aria-label={"fab"}
            color={"default"}
            onClick={onClickFab}
          >
            <LayersIcon fontSize={"large"} color="primary" />
          </Fab>
        </Box>

        <Box
          sx={{
            position: "absolute",
            top: 200,
            right: 16,
            borderRadius: 0,
            bgcolor: "transparent",
            zIndex: 500,
            pointerEvents: "none",
            display: "flex",
            alignItems: "flex-end",
            flexDirection: "column",
          }}
        >
          <Box style={{ pointerEvents: "none" }}>
            <CommandTrayAll />
          </Box>
        </Box>
      </Paper>

      <Modal open={!!missionSelect}>
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 900,
            height: 500,
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pointerEvents: "none",
          }}
        ></Box>
      </Modal>
    </>
  );
};

export const OverviewMap = Overview;
